"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Badge = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _theme = require("../theme");

var _core = require("@emotion/core");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var BEAT_TIME = 150;
var beatKeyframes = (0, _theme.keyframes)({
  '0%': {
    transform: "scale(1)"
  },
  '40%': {
    transform: 'scale(1.4)'
  },
  '100%': {
    transform: "scale(1)"
  }
});

var Badge = function Badge(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$count = _ref.count,
      count = _ref$count === void 0 ? 0 : _ref$count,
      dot = _ref.dot,
      flipIcon = _ref.flipIcon,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? null : _ref$icon,
      _ref$overflowCount = _ref.overflowCount,
      overflowCount = _ref$overflowCount === void 0 ? 99 : _ref$overflowCount,
      showForScreenReaders = _ref.showForScreenReaders,
      _ref$animated = _ref.animated,
      animated = _ref$animated === void 0 ? false : _ref$animated,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "className", "count", "dot", "flipIcon", "icon", "overflowCount", "showForScreenReaders", "animated"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      animating = _useState2[0],
      setAnimating = _useState2[1];

  var initialRender = (0, _react.useRef)(true);
  (0, _react.useEffect)(function () {
    if (animated && !initialRender.current) {
      setAnimating(true);
      setTimeout(function () {
        setAnimating(false);
      }, BEAT_TIME);
    }

    if (initialRender.current) {
      initialRender.current = false;
    }
  }, [count, animated]);
  var position = children ? 'absolute' : 'relative';
  var countCheck = count > overflowCount ? overflowCount + '+' : count;
  var type = icon ? 'icon' : 'notification';
  var showBadge = type === 'notification' && count > 0;
  return (0, _core.jsx)(BadgeContainer, {
    flipIcon: flipIcon
  }, !icon && showBadge && (0, _core.jsx)(BadgeComponent, (0, _extends2.default)({
    "aria-hidden": !showForScreenReaders,
    className: className,
    dot: dot,
    flipIcon: flipIcon,
    position: position,
    type: type,
    animating: animating
  }, props), !dot && countCheck), icon && (0, _core.jsx)(CustomIcon, {
    flipIcon: flipIcon
  }, icon), children);
};

exports.Badge = Badge;
var _default = Badge;
exports.default = _default;
var BadgeComponent = (0, _theme.styled)('i')(function (props) {
  var theme = props.theme,
      backgroundColor = props.backgroundColor,
      color = props.color,
      dot = props.dot,
      flipIcon = props.flipIcon,
      position = props.position,
      style = props.style,
      type = props.type,
      animating = props.animating;
  var componentStyles = theme.components.badge;
  var bgColor = backgroundColor ? backgroundColor : componentStyles.backgroundColor;
  var fontColor = color ? color : componentStyles.color;
  var iconMargin = flipIcon ? 'right' : 'left';
  var options = {
    fontColor: fontColor,
    bgColor: bgColor,
    iconMargin: iconMargin
  };
  var defaultStyles = componentStyles.defaults(options);
  var positionStyles = componentStyles.indicatorPosition[position]();
  var badgeStyles = componentStyles[type](options);
  var dotNoficationStyles = dot ? componentStyles.dot(options) : {};
  var animation = "".concat(beatKeyframes, " ").concat(BEAT_TIME, "ms ease-in");
  return _objectSpread({}, defaultStyles, {}, positionStyles, {}, badgeStyles, {}, dotNoficationStyles, {}, style, {
    animation: animating ? animation : 'none'
  });
});
var CustomIcon = (0, _theme.styled)('span')(function (_ref2) {
  var theme = _ref2.theme,
      flipIcon = _ref2.flipIcon,
      props = (0, _objectWithoutProperties2.default)(_ref2, ["theme", "flipIcon"]);
  var componentStyles = theme.components.badge;
  var iconMargin = flipIcon ? 'left' : 'right';

  var options = _objectSpread({}, props, {
    flipIcon: flipIcon,
    iconMargin: iconMargin
  });

  var iconStyles = componentStyles.iconPlacement(options);
  return _objectSpread({
    lineHeight: 0
  }, iconStyles);
});
var BadgeContainer = (0, _theme.styled)('div')(function (props) {
  var flipIcon = props.flipIcon;
  var flexDirection = flipIcon ? 'row-reverse' : 'row';
  var justifyContent = flipIcon ? 'flex-end' : 'flex-start';
  return {
    alignItems: 'center',
    display: 'inline-flex',
    flexDirection: flexDirection,
    justifyContent: justifyContent,
    position: 'relative',
    maxWidth: '100%'
  };
});